import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router, CanActivate, UrlTree } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../reducers';
import { ValidateSessionRequested, SessionExpirationRequested } from './store/session.actions';
import { sessionValid, sessionOnInit } from './store/session.selectors';
import { filter, map, first, tap } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';

@Injectable()
export class AuthGuard implements CanActivateChild, CanActivate {

	constructor( private store: Store<AppState>, private router: Router, private toastService: ToastService ) {
	}

	canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<boolean> {
		return this.canActivateChild( route, state );
	}

	canActivateChild( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<boolean> {
		this.store.dispatch( new ValidateSessionRequested() );
		return combineLatest( [ this.store.select( sessionValid ), this.store.select( sessionOnInit ) ] ).pipe(
			filter( ([valid, onInit]) => !onInit && valid != null ),
			first(),
			map( ([valid,onInit]) => {
				if( !valid ) {
					this.toastService.disable();
					this.store.dispatch( new SessionExpirationRequested() );
				}
				return valid;
			})
		);
	}

}

